import { tooltipsAtom } from '@/lib/atoms/atoms';
import { Tooltip as AntTooltip } from 'antd';
import { useAtomValue } from 'jotai';
import { FC, PropsWithChildren } from 'react';

interface AppTooltipProps extends PropsWithChildren {
  toolTipKey?: string;
}

export const AppTooltip: FC<AppTooltipProps> = ({ children, toolTipKey }) => {
  //@ts-ignore
  const { props } = children;
  const tooltips = useAtomValue(tooltipsAtom);
  const tooltip = tooltips.find((item) => item.key === toolTipKey);

  //not checking for this causes tooltip to stay stuck on screen
  return props?.disabled ? (
    <>{children}</>
  ) : (
    <AntTooltip
      placement="bottomRight"
      title={tooltip?.value}
      mouseLeaveDelay={0}
    >
      <span>{children}</span>
    </AntTooltip>
  );
};
